import { usePoint } from '../context/PointContext';
import { Link } from 'react-router-dom';

function InsufficientPointPopup() {
    const { point, requiredPoint, showInsufficientPopup, hidePointInsufficient } = usePoint();

    if (!showInsufficientPopup) {
        return null;
    }

    const shortfall = requiredPoint - point;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            padding: '20px'
        }} onClick={hidePointInsufficient}>
            <div style={{
                background: 'linear-gradient(180deg, #2a2a3a 0%, #1a1a2a 100%)',
                borderRadius: '20px',
                padding: '30px',
                maxWidth: '320px',
                width: '100%',
                textAlign: 'center',
                border: '1px solid rgba(255,255,255,0.1)'
            }} onClick={(e) => e.stopPropagation()}>
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>&#128176;</div>

                <h3 style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: '#fff',
                    marginBottom: '10px'
                }}>
                    포인트가 부족합니다
                </h3>

                <p style={{
                    fontSize: '14px',
                    color: '#aaa',
                    marginBottom: '20px',
                    lineHeight: '1.5'
                }}>
                    이 운세를 보려면 <span style={{ color: '#FFD700', fontWeight: 'bold' }}>{requiredPoint}P</span>가 필요합니다.
                    <br />
                    <span style={{ color: '#FF6B6B' }}>{shortfall}P</span> 더 필요해요!
                </p>

                <div style={{
                    background: 'rgba(255,255,255,0.05)',
                    borderRadius: '12px',
                    padding: '15px',
                    marginBottom: '20px'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '8px'
                    }}>
                        <span style={{ color: '#888', fontSize: '13px' }}>현재 포인트</span>
                        <span style={{ color: '#fff', fontWeight: 'bold' }}>{point.toLocaleString()}P</span>
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}>
                        <span style={{ color: '#888', fontSize: '13px' }}>필요 포인트</span>
                        <span style={{ color: '#FFD700', fontWeight: 'bold' }}>{requiredPoint.toLocaleString()}P</span>
                    </div>
                </div>

                <div style={{
                    background: 'rgba(255,215,0,0.1)',
                    borderRadius: '10px',
                    padding: '12px',
                    marginBottom: '20px',
                    border: '1px solid rgba(255,215,0,0.2)'
                }}>
                    <p style={{ fontSize: '12px', color: '#FFD700' }}>
                        &#128161; 출석체크로 포인트를 모아보세요!
                    </p>
                </div>

                <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                        onClick={hidePointInsufficient}
                        style={{
                            flex: 1,
                            padding: '14px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            color: '#aaa',
                            background: 'rgba(255,255,255,0.1)',
                            border: 'none',
                            borderRadius: '10px',
                            cursor: 'pointer'
                        }}
                    >
                        닫기
                    </button>
                    <Link
                        to="/lighthouse/point-history"
                        onClick={hidePointInsufficient}
                        style={{
                            flex: 1,
                            padding: '14px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            color: '#000',
                            background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                            border: 'none',
                            borderRadius: '10px',
                            textDecoration: 'none',
                            textAlign: 'center'
                        }}
                    >
                        내역보기
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default InsufficientPointPopup;
